<section class="progress-bar-container">
    <mat-progress-bar mode="determinate" value="{{progressValue}}"></mat-progress-bar>
    <div class="progress-text">Your progress</div>
</section>
